export const generateFullName = (data) => {
  const nameParts = [data?.title, data?.first_name, data?.middle_name, data?.last_name].filter(Boolean);
  // const capitalizedNames = nameParts.map((name) => capitalizeString(name));
  const fullName = nameParts.join(' ');

  return fullName;
};
